// extracted by mini-css-extract-plugin
export default {"ProfileDropDown__wrapper":"g3Rw_fPSoM","ProfileDropDown__linksWrapper":"fL1_usIJ8b","ProfileDropDown__termsCopyrightWrapper":"IpwOLyyog0"};